module.exports = __webpack_public_path__ + "img/connect.458f240e.png";